export const formDoableTypes = ["information_request", "emailed_request", "document_request", "enquiry"];

// Matches the link targets in ListDoable, except enquiries, which conveyancing lists elsewhere
export const doableHref = (doable) =>
  formDoableTypes.includes(doable.doable_type)
    ? `/dashboard/doable/${doable.id}`
    : `/requests/${doable.doable_type}/${doable.id}`;

// Staff can open the dashboard's requests but not the client-app forms, as in TodoList
export const canOpenDoable = (session, doable) =>
  session.session_type === "client" || formDoableTypes.includes(doable.doable_type);
